import { COLOR_UI_HIGHLIGHT, COLOR_GREEN_700 } from '@alltrails/shared/denali/tokens';
import { addLayer, removeLayer, addLayerEvent } from '../layers/layer_helpers';
import { createPolylineLayer, getNewPolylineLayerId } from '../layers/polylines';
import { addOrUpdateGeojsonSource } from '../sources/geojson_helpers';
import { addHoverPopupToMap } from '../event_handling/popup_helpers';
import { removeSource } from '../sources/source_helpers';

const NEW_POLYLINE_COORDINATES = [-1, 0, 1, 0];

const addPolylines = (map, id, geojson, sourceOpts = {}, opts = {}, addUnderLayerTypes = null, isMapCreatorPage) => {
  addOrUpdateGeojsonSource(map, id, geojson, sourceOpts);
  if (map.getLayer(id)) {
    return;
  }

  const newPolylineColorsFlag = __AT_DATA__.experiments?.['web-feed-polyline-color']?.value === 'on';
  // when drawing a map isMapCreatorPage is undefined
  if (isMapCreatorPage === undefined) {
    addLayer(map, createPolylineLayer(id, id, opts), addUnderLayerTypes);
  } else if (newPolylineColorsFlag && !isMapCreatorPage) {
    // loop thorugh the coordinates - for each coordinate add layer with polyline
    NEW_POLYLINE_COORDINATES.forEach((coord, i) => {
      addLayer(map, {
        id: getNewPolylineLayerId(id, i),
        type: 'line',
        source: id,
        layout: {
          'line-join': 'round',
          'line-cap': 'round'
        },
        paint: {
          'line-color': opts['line-color'] ? opts['line-color'] : i === 3 ? COLOR_UI_HIGHLIGHT : COLOR_GREEN_700,
          'line-width': i === 3 ? 4 : 2,
          'line-offset': coord * 3
        }
      }, addUnderLayerTypes);
    });
  } else {
    addLayer(map, createPolylineLayer(id, id, opts), addUnderLayerTypes);
  }
  if (opts && opts.renderPopup) {
    addLayerEvent(map, id, true, 'mouseenter', () => {
      map.getCanvas().style.cursor = 'pointer';
    });
    addLayerEvent(map, id, true, 'mouseleave', () => {
      map.getCanvas().style.cursor = map.customStyle.cursor;
    });

    addHoverPopupToMap(map, id, opts.renderPopup);
  }
};

const updatePolylines = (map, id, key, primaryValue, secondaryValue) => {
  const newPolylineColorsFlag = __AT_DATA__.experiments?.['web-feed-polyline-color']?.value === 'on';

  if (newPolylineColorsFlag) {
    NEW_POLYLINE_COORDINATES.forEach((_, i) => {
      if (i === 3) {
        map.setPaintProperty(getNewPolylineLayerId(id, i), key, primaryValue);
      } else {
        map.setPaintProperty(getNewPolylineLayerId(id, i), key, secondaryValue ?? primaryValue);
      }
    });
  } else {
    map.setPaintProperty(id, key, primaryValue);
  }
};

const removePolylines = (map, id) => {
  const newPolylineColorsFlag = __AT_DATA__.experiments?.['web-feed-polyline-color']?.value === 'on';
  if (newPolylineColorsFlag) {
    NEW_POLYLINE_COORDINATES.forEach((_, i) => {
      removeLayer(map, getNewPolylineLayerId(id, i));
    });
  } else {
    removeLayer(map, id);
  }
  removeSource(map, id);
};

export { addPolylines, removePolylines, updatePolylines };
